import { Page } from "../Components/page/Page.js";
import Title from "../Components/page/Title.js"
import { useNavigate } from "react-router-dom";
import { dateFromPython } from "../util.js";
import { useBalance } from "../lib/balance.js";
import { STATUS_COLOR as SALE_STATUS, useSellRequestList } from "../lib/sell-request.js";
import { TwinPersona } from "../Components/TwinPersona.js";
import { useTreasuryClient } from "../lib/client";
import { STATUS_COLOR as PURCHASE_STATUS, usePurchaseList } from "../lib/tdn-purchase.js";

export default function Dashboard() {
  const navigate = useNavigate();
  const treasury = useTreasuryClient();
  const { data: dq } = useBalance(treasury.tdnHash);
  const { data: sellRequests } = useSellRequestList();
  const { data: purchases } = usePurchaseList();

  function SellRequestList({ sellRequests }) {
    return <table className="w-full text-center select-none">
      <thead className="border-b-4 border-b-black sticky top-0 z-10 bg-white">
        <tr>
          <th className="py-2 border-b border-b-black">Timestamp</th>
          <th className="py-2 border-b border-b-black text-left">Seller</th>
          <th className="py-2 border-b border-b-black">Redeemed</th>
          <th className="py-2 border-b border-b-black">Expected payout</th>
          <th className="py-2 border-b border-b-black">Status</th>
        </tr>
      </thead>
      <tbody className="">
        {sellRequests
          ?.sort((a,b) => (b.updatedAt || b.createdAt) - (a.updatedAt || a.createdAt))
          ?.map(sr =>
            <tr key={sr.id}
                onClick={() => navigate(`/sell-request/${sr.id}`)}
                className="border-b-black border-b hover:bg-gray-100 cursor-pointer">
              <td className="py-2 w-32">{dateFromPython(sr.createdAt)}</td>
              <td className="text-left whitespace-nowrap text-nowrap max-w-96"><TwinPersona twinUrl={sr.seller} /></td>
              <td className=""><span className="font-mono">{(new Number(sr.sellValue)).toFixed(dq?.displayPrecision)}</span> {treasury.tdnMoniker}</td>
              <td className=""><span className="font-mono">{(new Number(sr.expectedPayout)).toFixed(2)}</span> {sr.expectedPayoutUnits}</td>
              <td className={`${SALE_STATUS[sr.status]} h-fit px-2 min-w-28 max-w-28 text-center`}>{sr.status.toUpperCase()}</td>
            </tr>
        )}
      </tbody>
    </table>
  }

  function PurchaseList({ purchases }) {
    return <table className="w-full text-center select-none">
      <thead className="border-b-4 border-b-black sticky top-0 z-10 bg-white">
        <tr>
          <th className="py-2 border-b border-b-black">Timestamp</th>
          <th className="py-2 border-b border-b-black text-left">Buyer</th>
          <th className="py-2 border-b border-b-black">Paid</th>
          <th className="py-2 border-b border-b-black">Sent</th>
          <th className="py-2 border-b border-b-black">Status</th>
        </tr>
      </thead>
      <tbody>
        {purchases
          ?.sort((a,b) => (b.updatedAt || b.createdAt) - (a.updatedAt || a.createdAt))
          ?.map(p =>
            <tr key={p.id}
                onClick={() => navigate(`/purchase/${p.id}`)}
                className="border-b-black border-b hover:bg-gray-100 cursor-pointer">
              <td className="py-2 w-32">{dateFromPython(p.createdAt)}</td>
              <td className="text-left whitespace-nowrap text-nowrap max-w-96"><TwinPersona twinUrl={p.destination} /></td>
              <td className=""><span className="font-mono">{(new Number(p.paidValue)).toFixed(2)}</span> {p.paidValueUnits}</td>

              {/* ↓↓↓ MAJOR HACK! REVERT WHEN TREASURY BACKEND STORES PURCHASE AMOUNT ↓↓↓ */}

              {/* <td className=""><span className="font-mono">{(new Number(p.purchaseAmount)).toFixed(2)}</span> {treasury.tdnMoniker}</td> */}
              <td className=""><span className="font-mono">{(new Number(p.paidValue*treasury.tdnPurchasePrice)).toFixed(dq?.displayPrecision)}</span> {treasury.tdnMoniker}</td>

              {/* ↑↑↑ MAJOR HACK! REVERT WHEN TREASURY BACKEND STORES PURCHASE AMOUNT ↑↑↑ */}


              <td className={`${PURCHASE_STATUS[p.status]} h-fit px-2 min-w-28 max-w-28 text-center`}>{p.status.toUpperCase()}</td>
            </tr>
        )}
      </tbody>
    </table>
  }

  return <Page>
    <Title>
      BALANCE (<span className="lowercase">{treasury.tdnHash?.slice(0, 8)}</span>)
    </Title>
    <div className="mb-8 ml-2 font-mono">{Number(dq?.balance).toFixed(dq?.displayPrecision)}</div>

    <div className="mb-2 flex flex-row justify-end gap-3">
        <a className="text-base hover:underline pl-8 bg-no-repeat bg-[url(/public/img/csv.svg)]" href={`/transactions?note=${treasury.tdnHash}`}>View transactions</a>
        <br></br>
        <a hidden={!treasury.isPurchaser}
            href="/purchase/create"
            className="text-base hover:underline pl-8 bg-no-repeat bg-[url(/public/img/transfer.svg)]"
            >
            Manually send purchased notes
        </a>
    </div>
    <hr></hr>
    <Title>Sell requests</Title>

    {/* TODO: add button to filter out completed requests */}
    <SellRequestList sellRequests={sellRequests} />
    <div className="my-8"><hr></hr></div>
    <Title>Purchases</Title>
    <PurchaseList purchases={purchases} />
  </Page>
}